/**
 * Mobile menu wiring for settings views.
 */
import { closeMobileMenu } from '../../modules/ui';
import type { SettingsElements } from './types';

export function setupMobileMenuHandlers(els: SettingsElements): void {
  if (els.mobileMenuClose) {
    els.mobileMenuClose.addEventListener('click', closeMobileMenu);
  }
  if (els.mobileMenuBackdrop) {
    els.mobileMenuBackdrop.addEventListener('click', closeMobileMenu);
  }
  if (els.mobileViewAllLots) {
    els.mobileViewAllLots.addEventListener('click', function () {
      els.viewModeToggle?.click();
      closeMobileMenu();
    });
  }
  // Note: mobileOpenOptions is now a link (<a>) to /options, so we just need to close the menu
  if (els.mobileOpenOptions) {
    els.mobileOpenOptions.addEventListener('click', function () {
      closeMobileMenu();
    });
  }
  if (els.mobileLogout) {
    els.mobileLogout.addEventListener('click', function () {
      els.logout?.click();
      closeMobileMenu();
    });
  }
}
